import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/menu_icons/Editare_profil.png'


const _withScopeId = n => (_pushScopeId("data-v-1dba4213"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "q-pa-lg ecran-container" }
const _hoisted_2 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_3 = { class: "app__page__title__container" }
const _hoisted_4 = {
  class: "app__page__title",
  style: {"white-space":"nowrap"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"position":"relative","width":"24px","height":"24px"}
}, null, -1))
const _hoisted_6 = { style: {"margin-left":"auto"} }
const _hoisted_7 = {
  key: 0,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_8 = { style: {"display":"flex","align-items":"center","flex-direction":"column","gap":"2px"} }
const _hoisted_9 = { class: "app__label--large" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" clear ")
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createTextVNode("create ")
const _hoisted_14 = {
  key: 1,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_15 = { class: "app__label--medium" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" clear ")
const _hoisted_18 = ["onClick"]
const _hoisted_19 = /*#__PURE__*/_createTextVNode("create ")
const _hoisted_20 = {
  key: 2,
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_21 = { class: "app__label--small" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" clear ")
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/_createTextVNode("create ")
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 0,
  class: "app__title--small",
  style: {"position":"absolute","left":"50%","margin-left":"-100px"}
}
const _hoisted_28 = {
  key: 1,
  class: "app__title--small",
  style: {"position":"absolute","left":"calc(50% - 100px)"}
}
const _hoisted_29 = { class: "flex__column--center" }
const _hoisted_30 = {
  key: 0,
  class: "app__color--gray"
}
const _hoisted_31 = { class: "app__property--medium" }
const _hoisted_32 = {
  key: 2,
  class: "app__label--medium"
}
const _hoisted_33 = { class: "flex__column--center" }
const _hoisted_34 = { class: "row no-wrap items-center q-pa-sm q-gutter-xs" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Pick Files")
const _hoisted_36 = {
  key: 3,
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = { class: "draggable__list--area" }
const _hoisted_39 = { style: {"grid-area":"notselected"} }
const _hoisted_40 = { class: "app__title--small" }
const _hoisted_41 = {
  class: "draggable__list--element",
  style: {"background-color":"rgba(167,151,42,0.13)"}
}
const _hoisted_42 = { class: "app__property--medium" }
const _hoisted_43 = { style: {"grid-area":"selected"} }
const _hoisted_44 = { class: "app__title--small" }
const _hoisted_45 = { class: "draggable__list--element" }
const _hoisted_46 = { class: "app__property--medium" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode()
const _hoisted_48 = { class: "app__details--medium" }
const _hoisted_49 = {
  class: "app__color--gray",
  style: {"grid-area":"help","text-align":"center","padding":"0.5rem"}
}
const _hoisted_50 = { style: {"display":"flex","justify-content":"flex-end"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_tree = _resolveComponent("q-tree")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_bar = _resolveComponent("q-bar")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_uploader_add_trigger = _resolveComponent("q-uploader-add-trigger")!
  const _component_q_uploader = _resolveComponent("q-uploader")!
  const _component_q_spinner_gears = _resolveComponent("q-spinner-gears")!
  const _component_q_img = _resolveComponent("q-img")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('message.manage_categories')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.$q.platform.is.desktop)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              style: {"margin-top":"1rem","margin-right":"1rem","background-color":"#9b7d32","color":"white"},
              padding: "xs",
              icon: "add",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openFormAddNewCategory('','','','')))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, {
                  "transition-show": "scale",
                  "transition-hide": "scale",
                  anchor: "top middle",
                  self: "bottom middle",
                  offset: [10, 10]
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.add_new_category')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_q_input, {
      outlined: "",
      modelValue: _ctx.filter,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filter) = $event)),
      label: _ctx.$t('message.search'),
      dense: ""
    }, {
      append: _withCtx(() => [
        (_ctx.filter !== '')
          ? (_openBlock(), _createBlock(_component_q_icon, {
              key: 0,
              name: "clear",
              class: "cursor-pointer",
              onClick: _ctx.resetFilter
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "label"]),
    _createVNode(_component_q_tree, {
      nodes: _ctx.treeDataCategories,
      "node-key": "appid",
      filter: _ctx.filter,
      "filter-method": _ctx.myFilterMethod,
      ref: "refTreeGrid",
      selected: _ctx.selected,
      "onUpdate:selected": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selected) = $event))
    }, {
      "default-header": _withCtx((prop) => [
        (prop.node.category_level=='1')
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_q_btn, {
                  flat: "",
                  icon: "arrow_drop_up",
                  onClick: ($event: any) => (_ctx.moveUP(prop.node.ord))
                }, null, 8, ["onClick"]),
                _createVNode(_component_q_item_label, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(prop.node.ord+1), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_q_btn, {
                  flat: "",
                  icon: "arrow_drop_down",
                  onClick: ($event: any) => (_ctx.moveDown(prop.node.ord))
                }, null, 8, ["onClick"])
              ]),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$i18n.locale == 'de' ? prop.node.name_de : _ctx.$i18n.locale == 'ro' ? prop.node.name_ro : _ctx.$i18n.locale == 'en' ? prop.node.name_en : prop.node.name_hu), 1),
              (prop.node.children.length==0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "material-icons cursor-pointer",
                    style: {"margin-left":"10px","color":"red","font-weight":"bolder"},
                    onClick: ($event: any) => (_ctx.deleteCategory(prop.node.pid,prop.node.name_ro))
                  }, [
                    _hoisted_11,
                    _createVNode(_component_q_tooltip, {
                      "transition-show": "scale",
                      "transition-hide": "scale",
                      anchor: "top middle",
                      self: "bottom middle",
                      offset: [10, 10]
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('message.delete')), 1)
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_10))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: "material-icons cursor-pointer",
                style: {"margin-left":"10px"},
                onClick: ($event: any) => (_ctx.openForModifyCategory(prop.node.pid))
              }, [
                _hoisted_13,
                _createVNode(_component_q_tooltip, {
                  "transition-show": "scale",
                  "transition-hide": "scale",
                  anchor: "top middle",
                  self: "bottom middle",
                  offset: [10, 10]
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.modify')), 1)
                  ]),
                  _: 1
                })
              ], 8, _hoisted_12)
            ]))
          : _createCommentVNode("", true),
        (prop.node.category_level=='2')
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$i18n.locale == 'de' ? prop.node.name_de : _ctx.$i18n.locale == 'ro' ? prop.node.name_ro : _ctx.$i18n.locale == 'en' ? prop.node.name_en : prop.node.name_hu), 1),
              (prop.node.children.length==0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "material-icons cursor-pointer",
                    style: {"margin-left":"10px","color":"red","font-weight":"bolder"},
                    onClick: ($event: any) => (_ctx.deleteCategory(prop.node.pid,prop.node.name_ro))
                  }, [
                    _hoisted_17,
                    _createVNode(_component_q_tooltip, {
                      "transition-show": "scale",
                      "transition-hide": "scale",
                      anchor: "top middle",
                      self: "bottom middle",
                      offset: [10, 10]
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('message.delete')), 1)
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_16))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: "material-icons cursor-pointer",
                style: {"margin-left":"10px"},
                onClick: ($event: any) => (_ctx.openForModifyCategory(prop.node.pid))
              }, [
                _hoisted_19,
                _createVNode(_component_q_tooltip, {
                  "transition-show": "scale",
                  "transition-hide": "scale",
                  anchor: "top middle",
                  self: "bottom middle",
                  offset: [10, 10]
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.modify')), 1)
                  ]),
                  _: 1
                })
              ], 8, _hoisted_18)
            ]))
          : _createCommentVNode("", true),
        (prop.node.category_level=='3')
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$i18n.locale == 'de' ? prop.node.name_de : _ctx.$i18n.locale == 'ro' ? prop.node.name_ro : _ctx.$i18n.locale == 'en' ? prop.node.name_en : prop.node.name_hu), 1),
              (prop.node.children.length==0)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "material-icons cursor-pointer",
                    style: {"margin-left":"10px","color":"red","font-weight":"bolder"},
                    onClick: ($event: any) => (_ctx.deleteCategory(prop.node.pid,prop.node.name_ro))
                  }, [
                    _hoisted_23,
                    _createVNode(_component_q_tooltip, {
                      "transition-show": "scale",
                      "transition-hide": "scale",
                      anchor: "top middle",
                      self: "bottom middle",
                      offset: [10, 10]
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('message.delete')), 1)
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_22))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: "material-icons cursor-pointer",
                style: {"margin-left":"10px"},
                onClick: ($event: any) => (_ctx.openForModifyCategory(prop.node.pid))
              }, [
                _hoisted_25,
                _createVNode(_component_q_tooltip, {
                  "transition-show": "scale",
                  "transition-hide": "scale",
                  anchor: "top middle",
                  self: "bottom middle",
                  offset: [10, 10]
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('message.modify')), 1)
                  ]),
                  _: 1
                })
              ], 8, _hoisted_24)
            ]))
          : _createCommentVNode("", true)
      ]),
      "default-body": _withCtx((prop) => [
        (prop.node.is_parent_for_articles=='n')
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(_component_q_btn, {
                outline: "",
                color: "#273233",
                icon: "add",
                label: _ctx.$t('message.new_subcategory'),
                size: "sm",
                "no-caps": "",
                onClick: ($event: any) => (_ctx.openFormAddNewCategory(prop.node.pid,prop.node.name_ro, prop.node.name_en, prop.node.name_hu, prop.node.name_de))
              }, null, 8, ["label", "onClick"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["nodes", "filter", "filter-method", "selected"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.isOpenDialogCategory,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.isOpenDialogCategory) = $event)),
      persistent: "",
      maximized: true,
      "transition-show": _ctx.dialogTransitionShow,
      "transition-hide": _ctx.dialogTransitionHide
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { class: "bg-white" }, {
          default: _withCtx(() => [
            _createVNode(_component_q_bar, null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  dense: "",
                  flat: "",
                  color: "black",
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                      name: "arrow_back_ios",
                      style: {"font-weight":"bold"}
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_directive_close_popup]
                ]),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.$t('message.edit_category')), 1))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.mobile)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_ctx.$t('message.edit_category')), 1))
                  : _createCommentVNode("", true),
                (_ctx.$q.platform.is.desktop)
                  ? (_openBlock(), _createBlock(_component_q_space, {
                      key: 2,
                      dense: ""
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_scroll_area, { style: {"height":"85vh","max-width":"99vw"} }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_29, [
                      _createVNode(_component_q_form, {
                        onSubmit: _ctx.onSubmitFormCategory,
                        onReset: _ctx.onResetFormCategory,
                        class: "q-gutter-md"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_input, {
                            outlined: "",
                            modelValue: _ctx.editingCategory.name_ro,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editingCategory.name_ro) = $event)),
                            label: _ctx.label_editing_category_ro,
                            "input-style": "color:black;font-weight: 900;",
                            counter: "",
                            style: {"min-width":"100px","max-width":"clamp(100px,70vw, 600px)"},
                            maxlength: "100",
                            rules: [val => !!val || _ctx.$t('message.enter_field')]
                          }, null, 8, ["modelValue", "label", "rules"]),
                          _createVNode(_component_q_input, {
                            outlined: "",
                            modelValue: _ctx.editingCategory.name_en,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editingCategory.name_en) = $event)),
                            label: _ctx.label_editing_category_en,
                            "input-style": "color:black;font-weight: 900;",
                            counter: "",
                            style: {"min-width":"100px","max-width":"clamp(100px,70vw, 600px)"},
                            maxlength: "100",
                            rules: [val => !!val || _ctx.$t('message.enter_field')]
                          }, null, 8, ["modelValue", "label", "rules"]),
                          _createVNode(_component_q_input, {
                            outlined: "",
                            modelValue: _ctx.editingCategory.name_hu,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editingCategory.name_hu) = $event)),
                            label: _ctx.label_editing_category_hu,
                            "input-style": "color:black;font-weight: 900;",
                            counter: "",
                            style: {"min-width":"100px","max-width":"clamp(100px,70vw, 600px)"},
                            maxlength: "100",
                            rules: [val => !!val || _ctx.$t('message.enter_field')]
                          }, null, 8, ["modelValue", "label", "rules"]),
                          _createVNode(_component_q_input, {
                            outlined: "",
                            modelValue: _ctx.editingCategory.name_de,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editingCategory.name_de) = $event)),
                            label: _ctx.label_editing_category_de,
                            "input-style": "color:black;font-weight: 900;",
                            counter: "",
                            style: {"min-width":"100px","max-width":"clamp(100px,70vw, 600px)"},
                            maxlength: "100",
                            rules: [val => !!val || _ctx.$t('message.enter_field')]
                          }, null, 8, ["modelValue", "label", "rules"]),
                          (_ctx.editingCategory.parent_pid && _ctx.editingCategory.parent_pid.toString().length>0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                                _createTextVNode(_toDisplayString(_ctx.$t('message.parent_category')) + ": ", 1),
                                _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$i18n.locale == 'de' ? _ctx.editingCategory.parent_name_de : _ctx.$i18n.locale == 'ro' ? _ctx.editingCategory.parent_name_ro :
                                                                                                                                                                                                      _ctx.$i18n.locale == 'en' ? _ctx.editingCategory.parent_name_en : _ctx.editingCategory.parent_name_hu), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.editingCategory.hasChilds=='n')
                            ? (_openBlock(), _createBlock(_component_q_checkbox, {
                                key: 1,
                                modelValue: _ctx.editingCategory.is_parent_for_articles,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editingCategory.is_parent_for_articles) = $event)),
                                label: _ctx.$t('message.contains_items'),
                                color: "teal",
                                "true-value": "y",
                                "false-value": "n"
                              }, null, 8, ["modelValue", "label"]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.$t('message.subcategory_exists')), 1)),
                          _createElementVNode("div", _hoisted_33, [
                            _createVNode(_component_q_uploader, {
                              ref: "inputImgForCategory",
                              label: _ctx.$t('message.upload_category_image'),
                              accept: ".jpg, .png, image/*",
                              "auto-upload": false,
                              color: "grey",
                              flat: "",
                              "hide-upload-button": true,
                              multiple: false,
                              style: {"min-width":"100px","max-width":"clamp(100px,70vw, 600px)"},
                              onAdded: _ctx.imgForCategoryWasAdded
                            }, {
                              header: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_34, [
                                  (scope.isUploading)
                                    ? (_openBlock(), _createBlock(_component_q_spinner, {
                                        key: 0,
                                        class: "q-uploader__spinner"
                                      }))
                                    : _createCommentVNode("", true),
                                  (scope.canAddFiles)
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 1,
                                        type: "a",
                                        icon: "add_box",
                                        round: "",
                                        dense: "",
                                        flat: "",
                                        label: _ctx.$t('message.upload_category_image')
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_uploader_add_trigger),
                                          _createVNode(_component_q_tooltip, null, {
                                            default: _withCtx(() => [
                                              _hoisted_35
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["label"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              _: 1
                            }, 8, ["label", "onAdded"]),
                            (_ctx.ImgCategoryString64.length>0 && _ctx.editingCategory.img==null)
                              ? (_openBlock(), _createBlock(_component_q_img, {
                                  key: 0,
                                  src: _ctx.ImgCategoryString64,
                                  "spinner-color": "white",
                                  style: {"min-width":"100px","max-width":"clamp(100px,50vw, 300px)","top":"-50px","margin":"auto"}
                                }, {
                                  loading: _withCtx(() => [
                                    _createVNode(_component_q_spinner_gears, { color: "white" })
                                  ]),
                                  _: 1
                                }, 8, ["src"]))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.editingCategory.is_parent_for_articles=='y')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                _createVNode(_component_q_select, {
                                  class: "form__input--sizes",
                                  outlined: "",
                                  modelValue: _ctx.editingCategory.um1,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.editingCategory.um1) = $event)),
                                  options: _ctx.optionsUM,
                                  label: _ctx.$t('message.measure_units')
                                }, null, 8, ["modelValue", "options", "label"]),
                                _hoisted_37,
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t('message.inactive_features')), 1),
                                    _createVNode(_component_draggable, {
                                      class: "list-group",
                                      list: _ctx.listDimensionsNotUsed,
                                      group: "people",
                                      itemKey: "value"
                                    }, {
                                      item: _withCtx(({ element}) => [
                                        _createElementVNode("div", _hoisted_41, [
                                          _createElementVNode("span", _hoisted_42, _toDisplayString(element.label), 1)
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["list"])
                                  ]),
                                  _createElementVNode("div", _hoisted_43, [
                                    _createElementVNode("span", _hoisted_44, _toDisplayString(_ctx.$t('message.active_features')), 1),
                                    _createVNode(_component_draggable, {
                                      class: "list-group",
                                      list: _ctx.listDimensionsUsed,
                                      group: "people",
                                      itemKey: "value"
                                    }, {
                                      item: _withCtx(({ element, index }) => [
                                        _createElementVNode("div", _hoisted_45, [
                                          _createElementVNode("span", _hoisted_46, _toDisplayString(element.label), 1),
                                          _hoisted_47,
                                          _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t('message.on_position')) + " " + _toDisplayString(index+1), 1)
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["list"])
                                  ]),
                                  _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.$t('message.hold_and_pull')), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_50, [
                            _createVNode(_component_q_btn, {
                              label: _ctx.$t('message.reset'),
                              type: "reset",
                              flat: "",
                              class: "q-ml-sm"
                            }, null, 8, ["label"]),
                            _createVNode(_component_q_btn, {
                              label: _ctx.$t('message.save'),
                              type: "submit",
                              style: {"background-color":"#9b7d32","color":"white"}
                            }, null, 8, ["label"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["onSubmit", "onReset"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "transition-show", "transition-hide"])
  ]))
}